module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-102.e6f0fec3.svg";